module.exports = __webpack_public_path__ + "static/media/urbangoothem03.90b82e3a.webp";